var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeworder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96289 9.30078L15.0004 15.6883L25.9629 9.33824",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0005 27.0133V15.6758",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4128 3.1L5.73777 6.81254C4.22527 7.65004 2.98779 9.75002 2.98779 11.475V18.5375C2.98779 20.2625 4.22527 22.3625 5.73777 23.2L12.4128 26.9126C13.8378 27.7001 16.1753 27.7001 17.6003 26.9126L24.2753 23.2C25.7878 22.3625 27.0253 20.2625 27.0253 18.5375V11.475C27.0253 9.75002 25.7878 7.65004 24.2753 6.81254L17.6003 3.1C16.1628 2.3 13.8378 2.3 12.4128 3.1Z",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2499 16.55V11.9751L9.38745 5.125",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeworder);
export default __webpack_public_path__ + "static/media/neworder.5ce1669b.svg";
export { ForwardRef as ReactComponent };